import {Space, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import TeamFotoUlt from './TeamFotoUlt.jsx';

const {Title} = Typography;

const TeamAtri = () => {
  return (
    <Layout className='PurpBack' style={{background: 'white'}}>
      <Layout style={{margin: '50px', background: 'inherit'}}>
        <Title level={1} style={{color: appColors['ColorA'], textAlign: 'center'}}>Attributions</Title>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly'}}>
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/gaby.png' nombre='Gabriela Rodríguez' puesto='Education' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/andybolivar.png' nombre='Andy Bolivar' puesto='Education' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/marianamuiz.jpeg' nombre='Mariana Muñiz' puesto='Human Practices' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Ulises Ramírez' puesto='Dry Lab' />
        </Space>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly', marginTop: '2%'}}>
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Ximena Gutiérrez' puesto='Animation' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Ximena Juárez' puesto='Animation' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Valeria Díaz' puesto='Video editing' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Rodrigo Huerta' puesto='Video editing' />
        </Space>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly', marginTop: '2%'}}>
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Megumi Pérez Guerra' puesto='Ilustrator' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Alexa González López' puesto='Ilustrator' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/imoage.png' nombre='Karla García Hernández' puesto='Ilustrator' />
        </Space>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly', marginTop: '2%'}}>
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/david-armando-chavaro-perez.jpeg' nombre='David Armando Chavaro Pérez' puesto='Wet Lab' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/oscarperez.png' nombre='Oscar Pérez Méndez' puesto='Wet Lab' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/marialuisadelprado.png' nombre='Maria Luisa del Prado' puesto='Wet Lab' />
        </Space>
        <Space align="start" style={{background: 'inherit', maxWidth: '100%', justifyContent: 'space-evenly', marginTop: '2%'}}>
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/laboratorio-de-soluciones-biomim-ticas.jpeg' nombre='Laboratorio Nacional de Soluciones Biomiméticas para Diagnóstico y Terapia' puesto='Wet Lab' />
          <TeamFotoUlt foto='https://static.igem.wiki/teams/4464/wiki/team/gingko.png' nombre='Ginkgo Bioworks' puesto='Wet Lab' />
        </Space>
      </Layout>
    </Layout>
  );
};

export default TeamAtri;
